export default function Footer() {
  return (
    <footer className="bg-[#1A1A1A] text-white py-14 md:py-20 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto">
        {/* Main Footer Content */}
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-10 md:mb-12">
          {/* Brand Column */}
          <div className="col-span-2 md:col-span-1">
            <img src="https://public.readdy.ai/ai/img_res/1609b5eb-0391-4869-9c8e-411d7ca8bbc2.png" alt="Logo" className="h-10 w-auto mb-5 brightness-0 invert" />
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Your trusted partner for professional home services. Quality workmanship and customer satisfaction guaranteed.
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-9 h-9 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#1e40af] transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#1e40af] transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#1e40af] transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#1e40af] transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold mb-5 text-sm sm:text-base">Quick Links</h4>
            <ul className="space-y-2.5">
              {[
                { href: '#services', label: 'Services' },
                { href: '#why-us', label: 'Why Choose Us' },
                { href: '#gallery', label: 'Gallery' },
                { href: '#testimonials', label: 'Testimonials' },
                { href: '#contact', label: 'Contact' },
                { href: '#', label: 'About Us' },
              ].map(link => (
                <li key={link.label}>
                  <a href={link.href} className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">{link.label}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-bold mb-5 text-sm sm:text-base">Services</h4>
            <ul className="space-y-2.5">
              {['Plumbing','HVAC','Electrical','Landscaping','Roofing','Remodeling'].map(s => (
                <li key={s}>
                  <a href="#services" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">{s}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="col-span-2 md:col-span-1">
            <h4 className="text-white font-bold mb-5 text-sm sm:text-base">Contact Us</h4>
            <ul className="space-y-3.5">
              <li className="flex items-start">
                <i className="ri-phone-line text-[#1e40af] mt-0.5 mr-3 flex-shrink-0"></i>
                <p className="text-gray-400 text-sm">(555) 123-4567</p>
              </li>
              <li className="flex items-start">
                <i className="ri-mail-line text-[#1e40af] mt-0.5 mr-3 flex-shrink-0"></i>
                <p className="text-gray-400 text-sm break-all">info@homeservices.com</p>
              </li>
              <li className="flex items-start">
                <i className="ri-map-pin-line text-[#1e40af] mt-0.5 mr-3 flex-shrink-0"></i>
                <p className="text-gray-400 text-sm">123 Main Street<br />Springfield, ST 12345</p>
              </li>
              <li className="flex items-start">
                <i className="ri-time-line text-[#1e40af] mt-0.5 mr-3 flex-shrink-0"></i>
                <p className="text-gray-400 text-sm">Mon-Fri: 7AM-7PM<br />Sat: 8AM-5PM<br />Sun: Closed</p>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 md:pt-8 border-t border-gray-800 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-gray-400 text-xs sm:text-sm">© 2024 Home Services. All rights reserved.</p>
          <div className="flex gap-4 sm:gap-6">
            <a href="#" className="text-gray-400 text-xs sm:text-sm hover:text-white transition-colors cursor-pointer">Privacy Policy</a>
            <a href="#" className="text-gray-400 text-xs sm:text-sm hover:text-white transition-colors cursor-pointer">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
